import React, { useEffect, useState } from "react";
import Header from "../layout/Header";
import Sidebar from "../layout/Sidebar";
import { Link, useParams, useLocation } from "react-router-dom";
import axios from "axios";
import { baseUrl } from "../../config/baseUrl";
export default function ReportView() {
  let [reportData, setReportData] = useState({});
  const [repotImg, setRepotImg] = useState({
    img: "",
    index: "",
    filter: "",
    issueName: "",
    issueReason: "",
  });
  const [images, setImages] = useState([]);
  const [issue, setIssue] = useState([]);
  const [postimages, setPostImages] = useState([]);
  const [damageimages, setDamageImages] = useState([]);
  const [graffitiimages, setGraffitiImages] = useState([]);
  const [otherimages, setOtherImages] = useState([]);
  let { id } = useParams();
  const location = useLocation();
  const prvpagedata = location.state;

  useEffect(() => {
    const report = async () => {
      let response = await axios(
        `${baseUrl}/module/mobile/report-viewset/${id}`,
        {
          method: "GET",
          headers: {
            Authorization: "Token " + localStorage.getItem("token"),
          },
        }
      );
      setReportData(response?.data?.data || []);
    };
    report();

    const issue_images = async () => {
      let response = await axios(
        `${baseUrl}/module/mobile/images_issues/${id}`,
        {
          method: "GET",
          headers: {
            Authorization: "Token " + localStorage.getItem("token"),
          },
        }
      );
      setImages(response?.data?.data?.images || []);
      setIssue(response?.data?.data?.issues || []);
      setPostImages(response?.data?.data?.postimages || []);
      setDamageImages(response?.data?.data?.damageimages || []);
      setGraffitiImages(response?.data?.data?.graffitiimages || []);
      setOtherImages(response?.data?.data?.otherimages || []);
    };
    issue_images();
  }, []);
  const handleDownloadReport = async () => {
    try {
      const response = await axios(
        `${baseUrl}/module/mobile/download_report_excel/${id}/`,
        {
          method: "GET",
          headers: {
            Authorization: "Token " + localStorage.getItem("token"),
          },
          responseType: "blob", // Important for file downloads
        }
      );

      // Create a blob from the response
      const blob = new Blob([response.data], {
        type:
          response.headers["content-type"] ||
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Create a temporary URL and trigger download
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `report_${id}.xlsx`);
      document.body.appendChild(link);
      link.click();

      // Clean up
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading report:", error);
      alert("Failed to download report. Please try again.");
    }
  };

  let changeImg = (slide) => {
    let index = repotImg.index;
    let imgCleaning = repotImg.filter;
    if (slide === "prv") {
      --index;
    } else {
      index++;
    }
    if (imgCleaning === "pre") {
      const filteredImages = images.filter((img) => img?.images);
      if (index < 0 || index >= filteredImages.length) {
        return;
      }
      setRepotImg((curlVal) => ({
        ...curlVal,
        img: filteredImages[index].images,
        index: index,
      }));
    }
    if (imgCleaning === "post") {
      const filteredImages = postimages.filter((img) => img?.postImages);
      if (index < 0 || index >= filteredImages.length) {
        return;
      }
      setRepotImg((curlVal) => ({
        ...curlVal,
        img: filteredImages[index].postImages,
        index: index,
      }));
    }
    if (imgCleaning === "damage") {
      const filteredImages = damageimages.filter((img) => img?.damage_post_images);
      if (index < 0 || index >= filteredImages.length) {
        return;
      }
      setRepotImg((curlVal) => ({
        ...curlVal,
        img: filteredImages[index].damage_post_images,
        index: index,
      }));
    }
    if (imgCleaning === "graffiti") {
      const filteredImages = graffitiimages.filter((img) => img?.graffiti_post_images);
      if (index < 0 || index >= filteredImages.length) {
        return;
      }
      setRepotImg((curlVal) => ({
        ...curlVal,
        img: filteredImages[index].graffiti_post_images,
        index: index,
      }));
    }
    if (imgCleaning === "otherImg" || imgCleaning === "otherDesc") {
      const filteredImages = otherimages.filter(
        (arr) => arr?.other_post_images || arr?.other_name
      );
      if (index < 0 || index >= filteredImages.length) {
        return;
      }
      setRepotImg((curlVal) => ({
        ...curlVal,
        img: filteredImages[index].other_post_images || "",
        issueName: filteredImages[index].other_name || "",
        issueReason: "",
        index: index,
        filter: filteredImages[index].other_post_images ? "otherImg" : "otherDesc",
      }));
    }
    if (imgCleaning === "isuueImg" || imgCleaning === "issueDesc") {
      const filteredImages = issue.filter(
        (arr) => arr?.issue_images || arr?.issue_name || arr?.issue_reason
      );
      if (index < 0 || index >= filteredImages.length) {
        return;
      }
      setRepotImg((curlVal) => ({
        ...curlVal,
        img: filteredImages[index].issue_images || "",
        issueName: filteredImages[index].issue_name || "",
        issueReason: filteredImages[index].issue_reason || "",
        index: index,
        filter: filteredImages[index].issue_images ? "isuueImg" : "issueDesc",
      }));
    }
  };

  // Helper function to get the current array length based on filter type
  const getCurrentArrayLength = () => {
    const filter = repotImg.filter;
    if (filter === "pre") {
      return images.filter((img) => img?.images).length;
    }
    if (filter === "post") {
      return postimages.filter((img) => img?.postImages).length;
    }
    if (filter === "damage") {
      return damageimages.filter((img) => img?.damage_post_images).length;
    }
    if (filter === "graffiti") {
      return graffitiimages.filter((img) => img?.graffiti_post_images).length;
    }
    if (filter === "otherImg" || filter === "otherDesc") {
      return otherimages.filter(
        (arr) => arr?.other_post_images || arr?.other_name
      ).length;
    }
    if (filter === "isuueImg" || filter === "issueDesc") {
      return issue.filter(
        (arr) => arr?.issue_images || arr?.issue_name || arr?.issue_reason
      ).length;
    }
    return 0;
  };

  // Check if previous button should be disabled
  const isPreviousDisabled = () => {
    return repotImg.index <= 0;
  };

  // Check if next button should be disabled
  const isNextDisabled = () => {
    const length = getCurrentArrayLength();
    return repotImg.index >= length - 1;
  };

  return (
    <>
      {/* <Header /> */}
      {/* <Sidebar activeItem={"ReportManagement"} /> */}
      <section className="main-sec">
        <div className="row">
          <div className="col-lg-12">
            <div className="dashboard-title d-flex justify-content-between align-items-center">
              <h4 className="dash-head">
                <i className="fa fa-flag me-2" />
                Report Details
              </h4>
              <button
                onClick={handleDownloadReport}
                className="btn btn-primary"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <i className="fa fa-download" />
                Download Report
              </button>
            </div>
            <div className="custom-bredcump">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Report Detail
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="cards">
              <div className="row justify-content-center">
                <div className="col-lg-8">
                  <div className="cards report-dtl">
                    <table className="table table-bordered dtl-table">
                      <tbody>
                        {/* <tr>
                          <th>ID</th>
                          <td>{reportData?.id}</td>
                        </tr> */}
                        <tr>
                          <th>Cleaner Name</th>
                          <td>{reportData?.name_cleaner}</td>
                        </tr>

                        <tr>
                          <th>Depot Name</th>
                          <td>{reportData?.depo?.depo_name}</td>
                        </tr>
                        <tr>
                          <th>Company Name</th>
                          <td>{reportData?.company?.company_name}</td>
                        </tr>
                        {reportData?.cleaning_type !== "REGULAR_CLEANING" && (
                          <tr>
                            <th>Pre-Cleaning Photos</th>
                            <td>
                              {images &&
                              Array.isArray(images) &&
                              images.length > 0 &&
                              images.some((img) => img?.images) ? (
                                <div className="table-img-box">
                                  {images
                                    .filter((img) => img?.images) // Filter out items without valid images
                                    .map((img, i) => (
                                      <button key={i}>
                                        <img
                                          src={`${img?.images}`}
                                          alt="reportImg"
                                          style={{ width: "8px" }}
                                          data-bs-toggle="modal"
                                          data-bs-target="#reportImg"
                                          onClick={() =>
                                            setRepotImg({
                                              img: img?.images,
                                              index: i,
                                              filter: "pre",
                                              issueName: "",
                                              issueReason: "",
                                            })
                                          }
                                        />
                                      </button>
                                    ))}
                                </div>
                              ) : null}
                            </td>
                          </tr>
                        )}
                        <tr>
                          <th>Post-Cleaning Photos </th>
                          <td>
                            {postimages &&
                            Array.isArray(postimages) &&
                            postimages.length > 0 &&
                            postimages.some((img) => img?.postImages) ? (
                                <div className="table-img-box">
                                {postimages
                                  .filter((img) => img?.postImages) // Filter out items without valid images
                                  .map((img, i) => (
                                    <button key={i}>
                                      <img
                                        src={`${img?.postImages}`}
                                        alt="reportImg"
                                        style={{ width: "8px" }}
                                        data-bs-toggle="modal"
                                        data-bs-target="#reportImg"
                                        onClick={() =>
                                          setRepotImg({
                                            img: img?.postImages,
                                            index: i,
                                            filter: "post",
                                            issueName: "",
                                            issueReason: "",
                                          })
                                        }
                                      />
                                    </button>
                                  ))}
                              </div>
                            ) : null}
                          </td>
                        </tr>
                        {/* <tr>
                          <th>issue</th>
                          <td>{reportData?.issue_name}</td>
                        </tr> */}
                        <tr>
                          <th>Location</th>
                          <td>{reportData?.location}</td>
                        </tr>
                        <tr>
                          <th>
                            {reportData?.cleaning_type === "REGULAR_CLEANING"
                              ? "Notes"
                              : "Work Description"}
                          </th>
                          <td>{reportData?.desc_of_work}</td>
                        </tr>
                        <tr>
                          <th>Date/Time</th>
                          <td>
                            {reportData?.date}/{" "}
                            {reportData?.time?.split(".")[0]}
                          </td>
                        </tr>

                        <tr>
                          <th>Damage Images</th>
                          <td>
                            {damageimages &&
                            Array.isArray(damageimages) &&
                            damageimages.length > 0 &&
                            damageimages.some(
                              (img) => img?.damage_post_images
                            ) ? (
                              <div className="table-img-box">
                                {damageimages
                                  .filter((img) => img?.damage_post_images) // Filter out items without valid images
                                  .map((img, i) => (
                                    <button key={i}>
                                      <img
                                        src={`${img?.damage_post_images}`}
                                        alt="reportImg"
                                        style={{ width: "8px" }}
                                        data-bs-toggle="modal"
                                        data-bs-target="#reportImg"
                                        onClick={() =>
                                          setRepotImg({
                                            img: img?.damage_post_images,
                                            index: i,
                                            filter: "damage",
                                            issueName: "",
                                            issueReason: "",
                                          })
                                        }
                                      />
                                    </button>
                                  ))}
                              </div>
                            ) : null}
                          </td>
                        </tr>
                        <tr>
                          <th>Graffiti Images</th>
                          <td>
                            {graffitiimages &&
                            Array.isArray(graffitiimages) &&
                            graffitiimages.length > 0 &&
                            graffitiimages.some(
                              (img) => img?.graffiti_post_images
                            ) ? (
                              <div className="table-img-box">
                                {graffitiimages
                                  .filter((img) => img?.graffiti_post_images) // Filter out items without valid images
                                  .map((img, i) => (
                                    <button key={i}>
                                      <img
                                        src={`${img?.graffiti_post_images}`}
                                        alt="reportImg"
                                        style={{ width: "8px" }}
                                        data-bs-toggle="modal"
                                        data-bs-target="#reportImg"
                                        onClick={() =>
                                          setRepotImg({
                                            img: img?.graffiti_post_images,
                                            index: i,
                                            filter: "graffiti",
                                            issueName: "",
                                            issueReason: "",
                                          })
                                        }
                                      />
                                    </button>
                                  ))}
                              </div>
                            ) : null}
                          </td>
                        </tr>
                        <tr>
                          <th>Emergency button pushed</th>
                          <td>
                            {reportData?.emergency === true ||
                            reportData?.emergency === "true"
                              ? "Yes"
                              : "No"}
                          </td>
                        </tr>

                        <tr>
                          <th>Other Images</th>
                          <td>
                            {otherimages &&
                            Array.isArray(otherimages) &&
                            otherimages.length > 0 &&
                            otherimages.some(
                              (arr) => arr?.other_post_images || arr?.other_name
                            ) ? (
                              <div className="table-img-box">
                                {otherimages
                                  .filter(
                                    (arr) =>
                                      arr?.other_post_images || arr?.other_name
                                  )
                                  .map((arr, i) => (
                                    <div
                                      key={i}
                                      style={{
                                        display: "inline-block",
                                        marginRight: "5px",
                                      }}
                                    >
                                      {arr?.other_post_images ? (
                                        <button>
                                          <img
                                            src={`${arr?.other_post_images}`}
                                            alt="reportImg"
                                            data-bs-toggle="modal"
                                            data-bs-target="#reportImg"
                                            style={{ width: "8px" }}
                                            onClick={() =>
                                              setRepotImg({
                                                img: arr?.other_post_images,
                                                issueName:
                                                  arr?.other_name || "",
                                                issueReason: "",
                                                index: i,
                                                filter: "otherImg",
                                              })
                                            }
                                          />
                                        </button>
                                      ) : arr?.other_name ? (
                                        <button
                                          style={{
                                            width: "8px",
                                            height: "56px",
                                            border: "1px solid #ddd",
                                            borderRadius: "2px",
                                            background: "#f5f5f5",
                                            display: "inline-block",
                                            cursor: "pointer",
                                            padding: 0,
                                            overflow: "hidden",
                                          }}
                                          data-bs-toggle="modal"
                                          data-bs-target="#reportImg"
                                          onClick={() =>
                                            setRepotImg({
                                              img: "",
                                              issueName: arr?.other_name || "",
                                              issueReason: "",
                                              index: i,
                                              filter: "otherDesc",
                                            })
                                          }
                                          title={arr?.other_name || "Issue"}
                                        />
                                      ) : null}
                                    </div>
                                  ))}
                              </div>
                            ) : null}
                          </td>
                        </tr>
                        <tr>
                          <th>Issue Images</th>
                          <td>
                            {issue &&
                            Array.isArray(issue) &&
                            issue.length > 0 &&
                            issue.some(
                              (arr) =>
                                arr?.issue_images ||
                                arr?.issue_name ||
                                arr?.issue_reason
                            ) ? (
                              <div className="table-img-box">
                                {issue
                                  .filter(
                                    (arr) =>
                                      arr?.issue_images ||
                                      arr?.issue_name ||
                                      arr?.issue_reason
                                  )
                                  .map((arr, i) => (
                                    <div
                                      key={i}
                                      style={{
                                        display: "inline-block",
                                        marginRight: "5px",
                                      }}
                                    >
                                      {arr?.issue_images ? (
                                        <button>
                                          <img
                                            src={`${arr?.issue_images}`}
                                            alt="reportImg"
                                            data-bs-toggle="modal"
                                            data-bs-target="#reportImg"
                                            style={{ width: "8px" }}
                                            onClick={() =>
                                              setRepotImg({
                                                img: arr?.issue_images,
                                                issueName:
                                                  arr?.issue_name || "",
                                                issueReason:
                                                  arr?.issue_reason || "",
                                                index: i,
                                                filter: "isuueImg",
                                              })
                                            }
                                          />
                                        </button>
                                      ) : arr?.issue_name ||
                                        arr?.issue_reason ? (
                                        <button
                                          style={{
                                            width: "8px",
                                            height: "56px",
                                            border: "1px solid #ddd",
                                            borderRadius: "2px",
                                            background: "#f5f5f5",
                                            display: "inline-block",
                                            cursor: "pointer",
                                            padding: 0,
                                            overflow: "hidden",
                                          }}
                                          data-bs-toggle="modal"
                                          data-bs-target="#reportImg"
                                          onClick={() =>
                                            setRepotImg({
                                              img: "",
                                              issueName: arr?.issue_name || "",
                                              issueReason:
                                                arr?.issue_reason || "",
                                              index: i,
                                              filter: "issueDesc",
                                            })
                                          }
                                          title={arr?.issue_name || "Issue"}
                                        />
                                      ) : null}
                                    </div>
                                  ))}
                              </div>
                            ) : null}
                          </td>
                        </tr>
                        {/* <tr>
                          <th>Signature</th>
                          <td>
                            <img
                              src={`${reportData?.signature_cleaner}`}
                              alt="reportImg"
                              className="sig-img"
                              data-bs-toggle="modal"
                              data-bs-target="#reportImg"
                              onClick={() =>
                                setRepotImg(reportData?.issue_images)
                              }
                            />
                          </td>
                        </tr> */}
                      </tbody>
                    </table>
                    {/* <button>exit</button> */}
                    <div className="col-lg-12 text-center">
                      <Link
                        // to="/report-list"
                        to={`/report-list`} // Path as string
                        state={prvpagedata}
                        // data
                        type="Submit"
                        className="thm-btn"
                        disabled
                      >
                        <i className="fa fa-chevron-left" /> &nbsp; back
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div
        className="modal fade"
        id="reportImg"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              {repotImg.img ? (
                <div>
                  <img src={`${repotImg.img}`} alt="img" />
                  {(repotImg.issueName || repotImg.issueReason) && (
                    <div style={{ padding: "15px 0", textAlign: "center" }}>
                      {repotImg.issueName && (
                        <h5
                          style={{ marginBottom: "10px", fontWeight: "bold" }}
                        >
                          {repotImg.issueName}
                        </h5>
                      )}
                      {repotImg.issueReason && (
                        <p
                          style={{
                            fontSize: "14px",
                            color: "#666",
                            lineHeight: "1.6",
                          }}
                        >
                          {repotImg.issueReason}
                        </p>
                      )}
                    </div>
                  )}
                </div>
              ) : (
                <div style={{ padding: "20px", textAlign: "center" }}>
                  {repotImg.issueName && (
                    <h5 style={{ marginBottom: "15px", fontWeight: "bold" }}>
                      {repotImg.issueName}
                    </h5>
                  )}
                  {repotImg.issueReason && (
                    <p
                      style={{
                        fontSize: "14px",
                        color: "#666",
                        lineHeight: "1.6",
                      }}
                    >
                      {repotImg.issueReason}
                    </p>
                  )}
                </div>
              )}
              {(repotImg.filter === "pre" ||
                repotImg.filter === "post" ||
                repotImg.filter === "damage" ||
                repotImg.filter === "graffiti" ||
                repotImg.filter === "isuueImg" ||
                repotImg.filter === "issueDesc" ||
                repotImg.filter === "otherImg" ||
                repotImg.filter === "otherDesc") && (
                <div className="btn-containermodel ">
                  <button
                    className="btn btn-info mt-3"
                    onClick={() => changeImg("prv")}
                    disabled={isPreviousDisabled()}
                    style={isPreviousDisabled() ? { opacity: 0.6, cursor: "not-allowed" } : {}}
                  >
                    Previous{" "}
                  </button>
                  <button
                    className="btn btn-success mt-3"
                    onClick={() => changeImg("next")}
                    disabled={isNextDisabled()}
                    style={isNextDisabled() ? { opacity: 0.6, cursor: "not-allowed" } : {}}
                  >
                    {" "}
                    Next{" "}
                  </button>
                </div>
              )}
            </div>
            {/* <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button type="button" className="btn btn-primary">
                <a href={barcodeValue}  target="_blank" download  >
                Download Now
                </a>
              </button>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
}
